/**
 * 从URL中获取某个参数值
 * @export
 * @param {string} name 参数名称
 * @param {string} defaultValue 默认值
 * @return {string} result 返回结果
 */
export function getParam(name, defaultValue) {
  defaultValue = defaultValue === undefined ? '' : defaultValue;
  var search = location.search || '?' + location.href.split('?')[1];
  var result = new RegExp('(\\?|&)' + name + '=(.*?)(&|$)', 'g').exec(search);
  return result ? decodeURIComponent(result[2]) : defaultValue;
}
